import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16H8",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12H8",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 8H8",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 3,
			width: 16,
			height: 18,
			rx: 4,
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgCardView;
